// Helper function.
// Get a number num that is between in_min and in_max and transform it into a number between out_min and out_max
const scale = function(num, in_min, in_max, out_min, out_max) {
	return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};

// Helper function.
// Takes a number with units (12px) and returns an array [12, 'px'].
const parseUnit = function(str) {
	var output = [];
	str = String(str);
	output[0] = parseFloat(str);
	output[1] = str.match(/[\d.\-+]*\s*(.*)/)[1] || '';
	return output;
};


/*
 * Lets you apply one or more css transform functions to the selected elements.
 * The value will depend on the position of the element.
 * Given a starting value for when the element enters the screen and an end value for when it leaves.
 * options can be given as parameter or set in html as data-smooth-scroll value.
 * The format is {"property": propertyName,"start": startValue,"end": endValue}
 * for example:
 * <div data-smooth-scroll='{"property": "translateY","start":"180px","end":"-180px"}'>
 * will make the div enter the screen 180px lower that its normal position and leave 180px higher,
 * therefore it will scroll faster than the rest of the page.
 * More than one transforms can be set on the same element as an array:
 * <div data-smooth-scroll='[{"property": "translateY","start":"180px","end":"-180px"},{"property": "scale","start":"1","end":"1.45"}]'>
 *
 */
export default class ScrollAnimations{
	constructor(element) {
		// console.log(element);
		if (!element) return;
		this.element = element;

		if (this.element.tagName.toLowerCase() === 'picture' ) return;
		this.isMobile = window.innerWidth < 768;

		this.element_height = this.element.getBoundingClientRect().height;
		this.element_width = this.element.getBoundingClientRect().width;

		this.offset = window.innerWidth / 100 * 0.5;
		this.options = [
			{
				'property': 'translateY',
				'start': '-100px',
				'end': '100px'
			},
			{
				'property': 'scale',
				'start': this.element_height < this.element_width ? (this.isMobile ? '1.8' : 1.3 + this.offset / 100 ) : '1.2',
				'end': this.element_height < this.element_width ? (this.isMobile ? '1.8' : 1.3 + this.offset / 100 ) : '1.2',
				// 'start': '1',
				// 'end': '1',
			},
		];
		// console.log(this.element.getAttribute('src'));
		// console.log(this.options);
		this.events();
	}

	// Interpolate current value of transform.
	getTransformValues(item) {
		// var scrollPosition = $window.scrollTop();
		let scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

		// var element_height = item.outerHeight();
		// let element_height = item.getBoundingClientRect().height;
		
		// var element_top_position = item.offset().top;
		let element_top_position = item.getBoundingClientRect().top + scrollPosition;
		let element_bottom_position = (element_top_position + this.element_height);


		let animationSettings;
		if ( item.getAttribute('data-smooth-scroll') ) {
			animationSettings = item.dataset.smoothScroll;
			animationSettings = JSON.parse(animationSettings);
		} else if (this.options) {
			animationSettings = this.options;
		}

		if ( Array.isArray(animationSettings) ) {
			animationSettings.forEach(function(setting){
				const start = parseUnit(setting.start)[0];
				const end = parseUnit(setting.end)[0];
				const unit = parseUnit(setting.start)[1];
				const current = scale(scrollPosition, (element_top_position - window.innerHeight), element_bottom_position, start, end);
				setting.current = current.toString() + unit;
			});
		} else {
			const start = parseUnit(animationSettings.start)[0];
			const end = parseUnit(animationSettings.end)[0];
			const unit = parseUnit(animationSettings.start)[1];
			const current = scale(scrollPosition, (element_top_position - window.innerHeight), element_bottom_position, start, end);
			animationSettings.current = current.toString() + unit;
		}

		return animationSettings;
	}

	// Write interpolated value as transform property.
	writeTransformProperty(item) {
		let value = '';
		let animationSettings = this.getTransformValues.bind(this)(item);

		if ( Array.isArray(animationSettings) ) {
			animationSettings.forEach(function(setting) {
				let transform = setting.property + '(' + setting.current + ') ';
				value = value.concat(transform);
			});
		} else {
			value = animationSettings.property + '(' + animationSettings.current + ') ';
		}
		return value;
	}

	// Check if element is in view and write transform css.
	runAnimations() {
		let window_height = window.innerHeight;
		let window_top_position = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		let window_bottom_position = (window_top_position + window_height);

		// let element_height = this.element.getBoundingClientRect().height;
		let element_top_position = this.element.getBoundingClientRect().top + window_top_position;
		let element_bottom_position = (element_top_position + this.element_height);

		if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
			this.element.style.transform = this.writeTransformProperty.bind(this)(this.element);
		}

		requestAnimationFrame(this.runAnimations.bind(this));
	}

	events() {
		['scroll', 'resize'].forEach( e => {
			window.addEventListener(e, this.runAnimations.bind(this), false);
		});
	}
}




